webpackJsonp([1],{

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);

var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyAE2VOfl1LCg-1Kwx-8ZSzaXHVLQZK4n_g',
  authDomain: 'honornine-d7c0e.firebaseapp.com',
  databaseURL: 'https://honornine-d7c0e.firebaseio.com',
  projectId: 'honornine-d7c0e',
  storageBucket: '',
  messagingSenderId: '1048507046921'
});

/* harmony default export */ __webpack_exports__["a"] = (firebaseApp);

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_masonry__ = __webpack_require__(99);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_masonry__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_Db__ = __webpack_require__(118);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feed',
  data: function data() {
    return {
      instagrams: [],
      imageWidth: 340,
      instaWidth: 1600,
      ww: null,
      atPage: 1,
      pageSize: 20
    };
  },

  computed: {
    grams: function grams() {
      if (this.instagrams.length < 1) {
        return [];
      }
      var arr = [];
      for (var i in this.instagrams) {
        if (this.instagrams.hasOwnProperty(i)) {
          arr.push(this.instagrams[i]);
        }
      }
      return arr.sort(function (a, b) {
        return b.created_time - a.created_time;
      });
    }
  },
  methods: {
    render: function render() {
      this.ww = window.innerWidth;
    },
    openGram: function openGram(gram) {
      this.$store.commit('setOverlay', {
        gram: gram,
        product: 'blue'
      });
      if (window.ga) {
        window.ga('send', 'event', 'Instagram', 'click', gram.id + ' - ' + gram.user.username);
        window.ga('clientTracker.send', 'event', 'Instagram', 'click', gram.id + ' - ' + gram.user.username);
      }
    },
    joinObjects: function joinObjects(source, target) {
      for (var key in source) {
        if (source.hasOwnProperty(key)) {
          target[key] = source[key];
        }
      }
    },
    getLatestInstagrams: function getLatestInstagrams() {
      var hashtag = '';
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://accomplice.se/services/socialacc/hashtag/' + hashtag).then(function (response) {
        self.instagrams = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getLatestSaved: function getLatestSaved() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__classes_Db__["a" /* default */].database().ref('grams').once('value').then(function (snapshot) {
        _this.instagrams = snapshot.val();
      });
    },
    getHeight: function getHeight(width, height, imageWidth) {
      return imageWidth * (height / width);
    }
  },
  beforeMount: function beforeMount() {
    //  this.render()
  },
  mounted: function mounted() {
    window.onresize = this.render;
    this.getLatestSaved();
  }
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footern',
  computed: {}
});

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'menuDesktop',
  methods: {
    scrollTo: function scrollTo(divId) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
        scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + divId).offset().top - 40
      }, 'slow');
      if (window.ga) {
        window.ga('send', 'event', 'Menu', 'click', divId);
        window.ga('clientTracker.send', 'event', 'Menu', 'click', divId);
      }
    }
  },
  mounted: function mounted() {
    window.onscroll = function () {
      var pos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var menu = document.getElementById('menu');
      if (pos > window.innerHeight / 1.5 + 50) {
        menu.setAttribute('class', 'menu-desktop down');
      } else {
        menu.setAttribute('class', 'menu-desktop');
      }
    };
  },

  components: {}
});

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'menuMobile',
  data: function data() {
    return {
      menuOpen: false
    };
  },

  methods: {
    goTo: function goTo(divId) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
        scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + divId).offset().top
      }, 'slow');
      if (window.ga) {
        window.ga('send', 'event', 'Menu Mobile', 'click', divId);
      }
      this.menuOpen = false;
    },
    openMenu: function openMenu() {
      if (this.menuOpen) {
        this.menuOpen = false;
      } else {
        this.menuOpen = true;
      }
    }
  },
  mounted: function mounted() {
    window.onscroll = function () {
      var pos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var menu = document.getElementById('menu');
      if (pos > window.innerHeight / 1.5 + 50) {
        menu.setAttribute('class', 'menu-desktop down');
      } else {
        menu.setAttribute('class', 'menu-desktop');
      }
    };
  },

  components: {}
});

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'overlay',
  computed: {
    gram: function gram() {
      return this.$store.state.overlay.gram;
    }
  }
});

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'products',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'splash',
  data: function data() {
    return {};
  },

  methods: {
    scrollTo: function scrollTo(divId) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
        scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + divId).offset().top - 40
      }, 'slow');
    }
  }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Feed__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Feed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Feed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Splash__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Splash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Splash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MenuDesktop__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MenuDesktop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MenuDesktop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MenuMobile__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MenuMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MenuMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Products__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Overlay__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footern__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Footern___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Footern__);
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'start',
  components: { Feed: __WEBPACK_IMPORTED_MODULE_0__components_Feed___default.a, Splash: __WEBPACK_IMPORTED_MODULE_1__components_Splash___default.a, MenuDesktop: __WEBPACK_IMPORTED_MODULE_2__components_MenuDesktop___default.a, Products: __WEBPACK_IMPORTED_MODULE_4__components_Products___default.a, Overlay: __WEBPACK_IMPORTED_MODULE_5__components_Overlay___default.a, MenuMobile: __WEBPACK_IMPORTED_MODULE_3__components_MenuMobile___default.a, Footern: __WEBPACK_IMPORTED_MODULE_6__components_Footern___default.a }
});

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d9f7b876",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cef4d348",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-796ed9bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(230),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69cfec66",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27a24c48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(227),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e0785f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(233),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9bfa45ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(228),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5684744e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-mobile",
    attrs: {
      "id": "menu"
    }
  }, [_c('a', {
    staticClass: "logotype",
    attrs: {
      "href": "http://hihonor.com",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hamburger",
    on: {
      "click": function($event) {
        _vm.openMenu()
      }
    }
  }, [_c('div', {
    class: {
      open: _vm.menuOpen
    },
    attrs: {
      "id": "nav-icon3"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "fold",
    class: {
      open: _vm.menuOpen
    }
  }, [_c('a', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.goTo('products')
      }
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.goTo('community')
      }
    }
  }, [_vm._v("Community")])])])
},staticRenderFns: []}

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.$store.commit('setOverlay', null)
      }
    }
  }, [_c('div', {
    staticClass: "close-but"
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "overlay-content"
  }, [_c('div', {
    staticClass: "instagram"
  }, [_c('img', {
    attrs: {
      "src": _vm.gram.images.standard_resolution.url
    }
  }), _vm._v(" "), (_vm.gram.type === 'youtube') ? _c('iframe', {
    attrs: {
      "width": "420",
      "height": "315",
      "src": 'https://www.youtube.com/embed/' + _vm.gram.id
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outside"
  }, [(_vm.gram.type === 'youtube') ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/watch?v=' + _vm.gram.id,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "profile",
    style: ({
      backgroundImage: 'url(' + _vm.gram.user.profile_picture + ')'
    })
  }), _vm._v(" " + _vm._s(_vm.gram.user.username))]) : _vm._e(), _vm._v(" "), (_vm.gram.type !== 'youtube') ? _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.gram.user.username,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "profile",
    style: ({
      backgroundImage: 'url(' + _vm.gram.user.profile_picture + ')'
    })
  }), _vm._v(" " + _vm._s(_vm.gram.user.username))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hearts"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v(" " + _vm._s(_vm.gram.likes.count))])])]), _vm._v(" "), (_vm.gram.color === 'blue') ? _c('a', {
    staticClass: "product product-blue",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  }) : _c('a', {
    staticClass: "product product-grey",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h1', {
    staticClass: "grey"
  }, [_vm._v("#MYHONOR")]), _vm._v(" "), _c('h1', {
    staticClass: "white"
  }, [_vm._v("COMMUNITY")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.scrollTo('community')
      }
    }
  }, [_vm._v("See Instagrams")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.instagram.com/lisatellbe/",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "iglink-one"
  }, [_vm._v("@lisatellbe")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.instagram.com/johnnyedlind/",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "iglink-two"
  }, [_vm._v("@johnnyedlind")])])
}]}

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-desktop",
    attrs: {
      "id": "menu"
    }
  }, [_c('a', {
    staticClass: "logotype",
    attrs: {
      "href": "http://hihonor.com",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.scrollTo('products')
      }
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.scrollTo('community')
      }
    }
  }, [_vm._v("Community")])])
},staticRenderFns: []}

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._v("\n\tKommer snart!\n")])
},staticRenderFns: []}

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start view"
  }, [(_vm.$store.state.overlay !== null) ? _c('overlay') : _vm._e(), _vm._v(" "), _c('menu-desktop'), _vm._v(" "), _c('menu-mobile'), _vm._v(" "), _c('splash'), _vm._v(" "), _c('products'), _vm._v(" "), _c('feed'), _vm._v(" "), _c('footern')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products",
    attrs: {
      "id": "products"
    }
  }, [_c('div', {
    staticClass: "products-content"
  }, [_c('a', {
    staticClass: "product product-blue",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "product product-black",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "product product-grey",
    attrs: {
      "href": "http://www.hihonor.com/se/products/mobile-phones/honor9/index.html",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear: both;"
  })])])
}]}

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footern"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "left-float"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/huaweisverige/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/Honorglobal",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/huawei/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/HuaweiSverige",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.huawei.com"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(216),
      "width": "170"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-float"
  }, [_vm._v("\n      COPYRIGHT ©HUAWEI HONOR 1998-2017.\n    ")])])])
}]}

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed",
    attrs: {
      "id": "community"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "feed-container"
  }, [_c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }],
    staticClass: "instagrams",
    attrs: {
      "transition-duration": "0.3s",
      "item-selector": ".instagram",
      "fit-width": "true"
    }
  }, _vm._l((_vm.grams), function(gram, index) {
    return ((_vm.pageSize * _vm.atPage) > index) ? _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "instagram",
      class: {
        youtube: gram.type === 'youtube'
      },
      style: ({
        backgroundImage: 'url(' + gram.images.standard_resolution.url + ')',
        width: _vm.imageWidth + 'px',
        height: _vm.getHeight(gram.images.standard_resolution.width, gram.images.standard_resolution.height, _vm.imageWidth) + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.openGram(gram)
        }
      }
    }, [_c('div', {
      staticClass: "inside"
    }, [_c('div', {
      staticClass: "table"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_c('div', {
      staticClass: "hearts"
    }, [_c('i', {
      staticClass: "fa fa-heart"
    }), _vm._v(" " + _vm._s(gram.likes.count))]), _c('br'), _vm._v("\n              " + _vm._s(gram.user.username) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "outside"
    }, [(gram.type !== 'youtube') ? _c('div', {
      staticClass: "profile",
      style: ({
        backgroundImage: 'url(' + gram.user.profile_picture + ')'
      })
    }) : _vm._e(), _vm._v(" "), (gram.type === 'youtube') ? _c('div', {
      staticClass: "profile"
    }, [_c('i', {
      staticClass: "fa fa-youtube"
    })]) : _vm._e(), _vm._v(" \n          " + _vm._s(gram.user.username) + "\n        ")])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "40px",
      "margin-top": "30px"
    }
  }, [(_vm.grams.length > (_vm.atPage * _vm.pageSize)) ? _c('div', {
    staticClass: "load-more button",
    on: {
      "click": function($event) {
        _vm.atPage++
      }
    }
  }, [_vm._v("See more")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feed-header"
  }, [_c('div', {
    staticClass: "tag"
  }, [_vm._v("#MYHONOR")]), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_vm._v("#FORTHEBRAVE")]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/huaweisverige/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  }), _vm._v(" Follow us on Instagram @huaweisverige")])])
}]}

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Start__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Start__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Start',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Start___default.a
  }, {
    path: '/kommersnart',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(239);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    overlay: null
  },
  mutations: {
    setOverlay: function setOverlay(state, value) {
      state.overlay = value;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(229),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[119]);


// WEBPACK FOOTER //
// static/js/app.e6907cd757ce58f3a008.js